import React, { useEffect, useState } from "react"
import * as Yup from "yup"
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Form,
  Row,
  Col,
  Spinner,
  Alert,
} from "reactstrap"
import { Formik, useFormik, validateYupSchema } from "formik"
import { Toast, ToastBody, ToastHeader } from "reactstrap"

import { useSelector, useDispatch } from "react-redux"
import axios from "axios"
const { Url, type, version, apiVersion } = configs.client
import configs from "../../../config"
import UnAuthorized from "store/auth/logout/UnAuthorized"
import UnAuthorizedPopup from "components/Common/UnAuthorized/UnAuthorizedPopup"
import { unAuthUser } from "store/actions"

export default function AddConversation({
  isOpen,
  toggle,
  fetchAllConversationsData,
  setShowSuccessToast,
}) {
  const { access, authorized } = useSelector(state => ({
    access: state.Login.userAccess,
    authorized: state.Login.authorized,
  }))
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(false)

  const dispatch = useDispatch()

  const AddConversationSchema = Yup.object().shape({
    name: Yup.string()
      .required("required")
      .matches(/^(?!\s+$).*/, "invalid"),
    description: Yup.string().matches(/^(?!\s+$).*/, "invalid"),
    bodyOn: Yup.string()
      .required(" required")
      .matches(/^(?!\s+$).*/, "invalid"),
    bodyOff: Yup.string()
      .required("required")
      .matches(/^(?!\s+$).*/, "invalid"),
  })

  // Formik
  const {
    handleChange,
    values,
    values: { Signature },
    handleSubmit,
    setFieldValue,
    resetForm,
    errors,
    handleBlur,
    touched,
  } = useFormik({
    initialValues: {
      name: "",
      description: "",
      bodyOn: "",
      bodyOff: "",
    },
    validationSchema: AddConversationSchema,
    onSubmit: values => {
      setIsLoading(true)
      resetForm()
      axios
        .post(`${Url}/${apiVersion}/conversations`, values, {
          headers: {
            "Content-Type": "application/json; charset=utf8",
            Authorization: `Bearer ${access}`,
          },
        })
        .then(res => {
          toggle()
          setIsLoading(false)
          setShowSuccessToast(true)
          setTimeout(() => setShowSuccessToast(false), 2500)
          fetchAllConversationsData()
          resetForm()
        })

        .catch(error => {
          setIsLoading(false)
          if (
            error.response.status === 401 ||
            error.response.status === 0 ||
            !error.response.status
          ) {
            dispatch(unAuthUser())

            setErrorMessage(error.response.data.message)
            setTimeout(() => setErrorMessage(false), 3500)
            setIsLoading(false)
          } else {
            setErrorMessage(error?.response?.data.message)
            setTimeout(() => setErrorMessage(false), 3500)
            setIsLoading(false)
          }
        })
    },
  })

  if (!authorized) {
    return <UnAuthorizedPopup />
  }

  const handleModalClosed = () => {
    resetForm()
  }

  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        onClosed={handleModalClosed}
        centered
        size="lg"
      >
        <ModalHeader toggle={toggle}>Add Conversation </ModalHeader>
        <ModalBody>
          {errorMessage && (
            <div className="" aria-live="polite" aria-atomic="true">
              <div className="">
                <Toast isOpen={errorMessage} fade={true}>
                  <ToastBody className="delete-message-bg">
                    <h5 className="m-0 mb-2">Error</h5>
                    <p className="m-0">{errorMessage}</p>
                  </ToastBody>
                </Toast>
              </div>
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <FormGroup className="m-0 m-mb-2">
              <Label className="mb-1 font-size-15">Conversation Name</Label>
              <Input
                className=" p-5px m-0"
                id="team-name"
                name="name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                // placeholder="Email"
                type="text"
              />
              {errors.name && touched.name && (
                <div className="error mb-0">{errors.name}</div>
              )}
            </FormGroup>

            <FormGroup className="m-0 m-mb-2">
              <Label className="mb-1 font-size-15">
                Conversation Description
              </Label>
              <Input
                className=" p-5px m-0"
                id="Conv-description"
                name="description"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.description}
                type="text"
              />
              {errors.description && touched.description && (
                <div className="error mb-0">{errors.description}</div>
              )}
            </FormGroup>

            <FormGroup className="m-0 m-mb-2">
              <Label className="mb-1 font-size-15">Inside Business Hour </Label>
              <Input
                className=" p-5px m-0"
                id="bodyOn"
                name="bodyOn"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.bodyOn}
                type="text"
              />
              {errors.bodyOn && touched.bodyOn && (
                <div className="error mb-0">{errors.bodyOn}</div>
              )}
            </FormGroup>

            <FormGroup className="m-0 m-mb-2">
              <Label className="mb-1 font-size-15">
                Outside Business Hour{" "}
              </Label>
              <Input
                className=" p-5px m-0"
                id="bodyOff"
                name="bodyOff"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.bodyOff}
                // placeholder="Email"
                type="text"
              />
              {errors.bodyOff && touched.bodyOff && (
                <div className="error mb-0">{errors.bodyOff}</div>
              )}
            </FormGroup>

            {isLoading && (
              <div className="loading-overlay">
                <Spinner />
              </div>
            )}

            <FormGroup className="d-flex justify-content-end gap-3 mt-3">
              <Button
                type="submit"
                color="secondary"
                className="py-1 px-4 font-size-16 rounded-2"
              >
                Add
              </Button>{" "}
              <Button
                onClick={toggle}
                color="outline-secondary"
                className="py-1 px-4 font-size-16 rounded-2"
              >
                Cancel
              </Button>
            </FormGroup>
          </form>
        </ModalBody>
      </Modal>
    </div>
  )
}
